<template>
  <div class="header-box">
    <div class="icon" @click="handleGoBack">
      <img class="back-icon" src="@/assets/img/my/back-icon.png" alt="" />
      <!-- 左侧标题，只有当 leftTitle 存在时才显示 -->
      <span v-if="leftTitle" class="left-title">{{ leftTitle }}</span>
    </div>
    <p class="title">{{ title }}</p>
  </div>
</template>


<script>
export default {
  name: 'MyHeader',
  props: {
    title: String,
    leftTitle: {
      type: String,
      default: '',
    },
    beforeGoBack: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleGoBack() {
      if (this.beforeGoBack) {
        const result = this.beforeGoBack();

        if (result instanceof Promise) {
          result.then((canGoBack) => {
            if (canGoBack) {
              this.goBack();
            }
          });
        } else if (result) {
          this.goBack();
        }
      } else {
        this.goBack();
      }
    },
    goBack() {
      if (this.$route.path === '/customer') {
        this.$router.push({
          path: '/my',
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.header-box {
  width: 100%;
  height: 64px;
  display: inline-flex;
  align-items: center;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    margin-left: 15px;

    .back-icon {
      width: 50px;
      height: 50px;
    }

    .left-title {
      font-size: 23px;
      font-weight: bold;
      margin-left: 10px;
      color: #666;

      /* 保持一行显示 */
      white-space: nowrap; /* 禁止换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 超出部分显示省略号（可选） */
      max-width: 150px; /* 设置最大宽度，避免过长内容溢出 */
    }
  }

  .title {
    width: 100%;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #222222;
    text-align: center;
    margin-right: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyHeader/MyHeader.vue